import { useEffect, useState } from 'react';
import client from '../api/client';

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY'
];

export default function RegionsAreas() {
  const [tab, setTab] = useState('regions');
  const [regions, setRegions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [modal, setModal] = useState(null); // null | { type: 'region'|'area', data: {} }
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    Promise.all([
      client.get('/admin/affiliate/regions'),
      client.get('/admin/affiliate/areas'),
      client.get('/admin/affiliate/reps'),
    ]).then(([r, a, rep]) => {
      setRegions(r.data || []);
      setAreas(a.data || []);
      setReps(rep.data || []);
    }).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openModal = (type, data = {}) => {
    setErr('');
    setModal({ type, data: { ...data } });
  };

  const closeModal = () => { setModal(null); setErr(''); };

  const save = async () => {
    setSaving(true); setErr('');
    try {
      const { type, data } = modal;
      if (type === 'region') {
        if (!data.name || !data.stateCode) return setErr('Name and state are required');
        if (data.id) await client.put('/admin/affiliate/regions/' + data.id, data);
        else await client.post('/admin/affiliate/regions', data);
        setMsg(data.id ? 'Region updated' : 'Region created');
      } else {
        if (!data.name || !data.regionId) return setErr('Name and region are required');
        if (data.id) await client.put('/admin/affiliate/areas/' + data.id, data);
        else await client.post('/admin/affiliate/areas', data);
        setMsg(data.id ? 'Area updated' : 'Area created');
      }
      closeModal(); load();
    } catch(e) { setErr(e.response?.data || 'Failed'); } finally { setSaving(false); }
  };

  const deactivate = async (type, id) => {
    if (!window.confirm('Deactivate this ' + type + '?')) return;
    try {
      await client.delete('/admin/affiliate/' + type + 's/' + id);
      setMsg(type.charAt(0).toUpperCase() + type.slice(1) + ' deactivated');
      load();
    } catch(e) { setErr(e.response?.data || 'Failed'); }
  };

  const inp = { width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' };
  const q = search.toLowerCase().trim();
  const filteredRegions = regions.filter(r => !q || (r.name||'').toLowerCase().includes(q) || (r.state_code||'').toLowerCase().includes(q) || (r.manager_name||'').toLowerCase().includes(q));
  const filteredAreas = areas.filter(a => !q || (a.name||'').toLowerCase().includes(q) || (a.region_name||'').toLowerCase().includes(q) || (a.city||'').toLowerCase().includes(q) || (a.manager_name||'').toLowerCase().includes(q));

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ color:'#000', fontSize:22, fontWeight:800, margin:'0 0 4px', fontFamily:'Georgia,serif' }}>Regions & Areas</h1>
          <p style={{ color:'#555', fontSize:13, margin:0 }}>Manage geographic regions and areas for commission routing</p>
        </div>
        <button style={{ padding:'10px 20px', background:'#1a3cff', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
          onClick={() => openModal(tab === 'regions' ? 'region' : 'area')}>
          + Add {tab === 'regions' ? 'Region' : 'Area'}
        </button>
      </div>

      {msg && <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:8, padding:'10px 16px', color:'#0a8a40', fontSize:13, marginBottom:16 }}>{msg} <button onClick={()=>setMsg('')} style={{ background:'none', border:'none', color:'#0a8a40', cursor:'pointer', marginLeft:8 }}>✕</button></div>}
      {err && !modal && <div style={{ background:'#fff5f5', border:'1px solid #fca5a5', borderRadius:8, padding:'10px 16px', color:'#c0392b', fontSize:13, marginBottom:16 }}>{err}</div>}

      <div style={{ marginBottom:16 }}>
        <input value={search} onChange={e=>{ setSearch(e.target.value); const v=e.target.value.toLowerCase().trim(); if(v){ const areaMatch=areas.some(a=>(a.name||'').toLowerCase().includes(v)||(a.region_name||'').toLowerCase().includes(v)||(a.city||'').toLowerCase().includes(v)||(a.manager_name||'').toLowerCase().includes(v)); const regionMatch=regions.some(r=>(r.name||'').toLowerCase().includes(v)||(r.state_code||'').toLowerCase().includes(v)||(r.manager_name||'').toLowerCase().includes(v)); if(areaMatch && !regionMatch) setTab('areas'); if(regionMatch && !areaMatch) setTab('regions'); } }} placeholder='Search states, areas, cities, regional managers, or area managers...' style={{ width:'100%', maxWidth:650, padding:'12px 16px', border:'1px solid #ddd', borderRadius:10, fontSize:15, color:'#000', outline:'none' }} />
      </div>

      <div style={{ display:'flex', gap:8, marginBottom:20, borderBottom:'1px solid #eee', paddingBottom:12 }}>
        {['regions','areas'].map(t => (
          <button key={t} onClick={()=>setTab(t)}
            style={{ padding:'8px 18px', background:tab===t?'#1a3cff':'#fff', color:tab===t?'#fff':'#444', border:tab===t?'none':'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}>
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      {loading ? <div style={{ color:'#888', padding:40, textAlign:'center' }}>Loading...</div> : (

        tab === 'regions' ? (
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
              <thead>
                <tr style={{ background:'#f9f9f9', borderBottom:'1px solid #eee' }}>
                  {['Region Name','State','Manager','Areas','Status','Actions'].map(h => (
                    <th key={h} style={{ color:'#555', fontSize:12, fontWeight:700, textAlign:'left', padding:'12px 16px', textTransform:'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredRegions.length === 0 ? (
                  <tr><td colSpan={6} style={{ color:'#888', padding:24, textAlign:'center' }}>No regions yet — add your first region</td></tr>
                ) : filteredRegions.map(r => (
                  <tr key={r.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                    <td style={{ padding:'12px 16px', color:'#000', fontWeight:700 }}>{r.name}</td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background:'#eff4ff', color:'#1a3cff', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>{r.state_code}</span>
                    </td>
                    <td style={{ padding:'12px 16px', color:'#333', fontSize:13 }}>{r.manager_name || <span style={{ color:'#aaa' }}>Unassigned</span>}</td>
                    <td style={{ padding:'12px 16px', color:'#555', fontSize:13 }}>
                      {areas.filter(a => a.region_id === r.id).length} areas
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background:r.is_active?'#f0fff6':'#fff5f5', color:r.is_active?'#0a8a40':'#c0392b', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>
                        {r.is_active ? 'ACTIVE' : 'INACTIVE'}
                      </span>
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ display:'flex', gap:6 }}>
                        <button style={{ padding:'6px 12px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={() => openModal('region', r)}>Edit</button>
                        <button style={{ padding:'6px 12px', background:'#fff5f5', color:'#c0392b', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={() => deactivate('region', r.id)}>Deactivate</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
              <thead>
                <tr style={{ background:'#f9f9f9', borderBottom:'1px solid #eee' }}>
                  {['Area Name','Region','City','Manager','Status','Actions'].map(h => (
                    <th key={h} style={{ color:'#555', fontSize:12, fontWeight:700, textAlign:'left', padding:'12px 16px', textTransform:'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredAreas.length === 0 ? (
                  <tr><td colSpan={6} style={{ color:'#888', padding:24, textAlign:'center' }}>No areas yet — add your first area</td></tr>
                ) : filteredAreas.map(a => (
                  <tr key={a.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                    <td style={{ padding:'12px 16px', color:'#000', fontWeight:700 }}>{a.name}</td>
                    <td style={{ padding:'12px 16px', color:'#333', fontSize:13 }}>{a.region_name || '—'}</td>
                    <td style={{ padding:'12px 16px', color:'#555', fontSize:13 }}>{a.city || '—'}</td>
                    <td style={{ padding:'12px 16px', color:'#333', fontSize:13 }}>{a.manager_name || <span style={{ color:'#aaa' }}>Unassigned</span>}</td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background:a.is_active?'#f0fff6':'#fff5f5', color:a.is_active?'#0a8a40':'#c0392b', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>
                        {a.is_active ? 'ACTIVE' : 'INACTIVE'}
                      </span>
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ display:'flex', gap:6 }}>
                        <button style={{ padding:'6px 12px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={() => openModal('area', { ...a, regionId: a.region_id, managerRepId: a.manager_rep_id })}>Edit</button>
                        <button style={{ padding:'6px 12px', background:'#fff5f5', color:'#c0392b', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={() => deactivate('area', a.id)}>Deactivate</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:460, border:'1px solid #eee', maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ color:'#000', margin:'0 0 20px', fontFamily:'Georgia,serif', fontSize:18 }}>
              {modal.data.id ? 'Edit' : 'Add'} {modal.type === 'region' ? 'Region' : 'Area'}
            </h3>
            {err && <div style={{ background:'#fff5f5', border:'1px solid #fca5a5', borderRadius:8, padding:'10px 14px', color:'#c0392b', fontSize:13, marginBottom:14 }}>{err}</div>}

            {modal.type === 'region' ? (
              <>
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>Region Name *</label>
                <input style={inp} placeholder="e.g. Texas Region" value={modal.data.name||''} onChange={e=>setModal(m=>({...m, data:{...m.data, name:e.target.value}}))} />
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>State *</label>
                <select style={inp} value={modal.data.stateCode||''} onChange={e=>setModal(m=>({...m, data:{...m.data, stateCode:e.target.value}}))}>
                  <option value="">Select state</option>
                  {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>Regional Manager (optional)</label>
                <select style={inp} value={modal.data.managerRepId||''} onChange={e=>setModal(m=>({...m, data:{...m.data, managerRepId:e.target.value}}))}>
                  <option value="">Unassigned</option>
                  {reps.filter(r=>r.is_active || r.isActive).map(r => <option key={r.id} value={r.id}>{r.name} ({r.ref_code})</option>)}
                </select>
              </>
            ) : (
              <>
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>Area Name *</label>
                <input style={inp} placeholder="e.g. Dallas Metro" value={modal.data.name||''} onChange={e=>setModal(m=>({...m, data:{...m.data, name:e.target.value}}))} />
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>Region *</label>
                <select style={inp} value={modal.data.regionId||''} onChange={e=>setModal(m=>({...m, data:{...m.data, regionId:e.target.value}}))}>
                  <option value="">Select region</option>
                  {regions.filter(r=>r.is_active).map(r => <option key={r.id} value={r.id}>{r.name} ({r.state_code})</option>)}
                </select>
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>City</label>
                <input style={inp} placeholder="e.g. Dallas" value={modal.data.city||''} onChange={e=>setModal(m=>({...m, data:{...m.data, city:e.target.value}}))} />
                <label style={{ fontSize:12, fontWeight:700, color:'#333', textTransform:'uppercase', display:'block', marginBottom:6 }}>Area Manager (optional)</label>
                <select style={inp} value={modal.data.managerRepId||''} onChange={e=>setModal(m=>({...m, data:{...m.data, managerRepId:e.target.value}}))}>
                  <option value="">Unassigned</option>
                  {reps.filter(r=>r.is_active || r.isActive).map(r => <option key={r.id} value={r.id}>{r.name} ({r.ref_code})</option>)}
                </select>
              </>
            )}

            <div style={{ display:'flex', gap:10, marginTop:8 }}>
              <button style={{ flex:1, padding:'11px', background:'#1a3cff', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:saving?'not-allowed':'pointer', opacity:saving?0.6:1 }}
                onClick={save} disabled={saving}>{saving?'Saving...':'Save'}</button>
              <button style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
                onClick={closeModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
